/**
 * Service worker kaydı ve GÜNCELLEME UYARISI.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * YENİ SÜRÜM KENDİLİĞİNDEN DEVRALMIYOR — ve bu bilinçli.
 *
 * `skipWaiting()` kurulur kurulmaz çağrılsaydı, kullanıcı bir formu
 * doldururken sayfa altından kod değişebilirdi. Bunun yerine yeni sürüm
 * BEKLİYOR ve arayüz "yeni sürüm var" diyor; devralma kullanıcı basınca
 * oluyor.
 *
 * Uyarı olmasaydı da kötüydü: service worker'lı bir uygulamada kullanıcılar
 * eski kodla GÜNLERCE çalışabilir ve düzeltilmiş bir hatayı görmeye devam
 * ederler.
 * ═══════════════════════════════════════════════════════════════════════════
 */

export type GuncellemeDinleyici = (uygula: () => void) => void;

/**
 * Kaydı yapar; yeni sürüm beklemeye geçtiğinde `dinleyici`yi çağırır.
 *
 * Geliştirmede KAYIT YAPILMAZ: service worker önbelleği sıcak yeniden
 * yüklemeyle çakışır ve "değişikliğim neden görünmüyor" saatleri üretir.
 */
export function swKaydet(dinleyici: GuncellemeDinleyici): void {
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  void navigator.serviceWorker
    .register('/sw.js')
    .then((kayit) => {
      // Sayfa açılırken zaten bekleyen bir sürüm olabilir.
      if (kayit.waiting) dinleyici(() => uygula(kayit));

      kayit.addEventListener('updatefound', () => {
        const yeni = kayit.installing;
        if (!yeni) return;
        yeni.addEventListener('statechange', () => {
          /*
           * `controller` yoksa bu İLK kurulumdur — "yeni sürüm var" demek
           * yanlış olurdu, kullanıcı uygulamayı ilk kez açıyor.
           */
          if (yeni.state === 'installed' && navigator.serviceWorker.controller) {
            dinleyici(() => uygula(kayit));
          }
        });
      });
    })
    .catch(() => {
      /* Kayıt başarısızsa uygulama normal çalışır; PWA bir EK özelliktir. */
    });
}

function uygula(kayit: ServiceWorkerRegistration): void {
  kayit.waiting?.postMessage('SKIP_WAITING');
  // Devralma tamamlanınca sayfa yenilenir: yeni kod ancak öyle çalışır.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}
